import makeStyles from '@mui/styles/makeStyles'

const getColor = (isGroup, isPersonalSpace, theme) => {
  if (isPersonalSpace) {
    return '#B64FCD'
  }
  if (isGroup) {
    return theme.palette.notification.group
  }

  return 'transparent'
}

const useStyles = makeStyles(theme => ({
  holder: {
    display: 'flex',
    alignItems: 'center'
  },

  root: {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: '4px 64px 390px',
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    maxHeight: '61px',
    backgroundColor: ({ selected }) => (selected ? '#F6F7F8' : 'white'),
    transition: 'background-color 0.75s',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: '#F6F7F8'
    },

    '& > div': {
      maxHeight: '61px'
    },

    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '4px 64px 1fr'
    }
  },

  animatedRoot: {
    animation: '$blink 2s infinite'
  },

  border: {
    marginTop: '-2px',
    marginBottom: '-2px',
    width: '4px',
    height: '61px',
    background: `linear-gradient(0deg, ${theme.gradient.button.start} 0%, ${theme.gradient.button.stop} 100%)`
  },

  type: {
    gridColumn: '1 / 2',
    position: 'absolute',
    top: '0',
    left: '0',
    width: '4px',
    height: '61px',
    backgroundColor: ({ isGroup, isPersonalSpace }) =>
      getColor(isGroup, isPersonalSpace, theme)
  },

  '@keyframes blink': {
    '0%': {
      backgroundColor: 'white'
    },
    '50%': {
      backgroundColor: '#BAE7F2'
    }
  }
}))

export default useStyles
